import { useMemo } from 'react';
import { CURRENCIES, BASE_PRICING } from '../constants';

export const usePricing = (currency, numComplianceReports = 1, employeeSizeStep = 3) => {
  const pricing = useMemo(() => {
    const base = {
      complianceReporting: BASE_PRICING.complianceReporting.map((item) => ({ ...item })),
      globalPayEquityModeling: BASE_PRICING.globalPayEquityModeling.map((item) => ({ ...item })),
    };

    Object.keys(CURRENCIES).forEach((currencyKey) => {
      base.complianceReporting.forEach((item) => {
        item[currencyKey] = CURRENCIES[currencyKey].conversion(item.usd);
      });
      base.globalPayEquityModeling.forEach((item) => {
        item[currencyKey] = CURRENCIES[currencyKey].conversion(item.usd);
      });
    });

    return base;
  }, []);

  const pricePerReport = useMemo(
    () => pricing.complianceReporting[numComplianceReports - 1][currency],
    [pricing.complianceReporting, currency, numComplianceReports],
  );

  const totalPrice = useMemo(
    () => pricing.complianceReporting[numComplianceReports - 1][currency] * numComplianceReports,
    [pricing.complianceReporting, currency, numComplianceReports],
  );

  const currentEmployeePrice = useMemo(
    () => pricing.globalPayEquityModeling[employeeSizeStep - 1][currency],
    [pricing.globalPayEquityModeling, currency, employeeSizeStep],
  );

  return {
    pricing,
    pricePerReport,
    totalPrice,
    currentEmployeePrice,
    currencies: CURRENCIES,
  };
};
